import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity, ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-lasten-personeelsbeloningen',
  templateUrl: './spec-lasten-personeelsbeloningen.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-lasten-personeelsbeloningen.component.scss']
})
export class SpecLastenPersoneelsbeloningenComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public employeeBenefitsExpensesFg = {} as FormGroup;
  public wagesSalariesFg = {} as FormGroup;
  public severancePaymentsFg = {} as FormGroup;
  public shareBasedPaymentsIncludedWagesSalariesFg = {} as FormGroup;
  public socialSecurityContributionsFg = {} as FormGroup;
  public pensionPremiumsFg = {} as FormGroup;
  public pensionExpensesAdditionalFg = {} as FormGroup;
  public employeeBenefitsExpensesOtherFg = {} as FormGroup;
  public employeeBenefitsExpensesDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.employeeBenefitsExpensesFg = this.jrDataService.createFormGroupBalanceItem()
    this.wagesSalariesFg = this.jrDataService.createFormGroupBalanceItem();
    this.severancePaymentsFg = this.jrDataService.createFormGroupBalanceItem();
    this.shareBasedPaymentsIncludedWagesSalariesFg = this.jrDataService.createFormGroupBalanceItem();
    this.socialSecurityContributionsFg = this.jrDataService.createFormGroupBalanceItem();
    this.pensionPremiumsFg = this.jrDataService.createFormGroupBalanceItem();
    this.pensionExpensesAdditionalFg = this.jrDataService.createFormGroupBalanceItem();
    this.employeeBenefitsExpensesOtherFg = this.jrDataService.createFormGroupBalanceItem();
    this.employeeBenefitsExpensesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const lastenUitHoofdePersoneelsbeloningen = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.lastenUitHoofdePersoneelsbeloningen;

    if (lastenUitHoofdePersoneelsbeloningen) {
      this.employeeBenefitsExpensesFg.reset();

      if (lastenUitHoofdePersoneelsbeloningen.employeeBenefitsExpenses) {
        this.employeeBenefitsExpensesFg.patchValue(lastenUitHoofdePersoneelsbeloningen.employeeBenefitsExpenses, {emitEvent: false})
      }

      const uitsplitsing = lastenUitHoofdePersoneelsbeloningen.lastenUitHoofdePersoneelsbeloningenUitsplitsing;
      const tekstueel = lastenUitHoofdePersoneelsbeloningen.lastenUitHoofdePersoneelsbeloningenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing?.wagesSalaries) {
          const subItem = uitsplitsing.wagesSalaries;
          this.wagesSalariesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.wagesSalariesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.severancePayments) {
          const subItem = uitsplitsing.severancePayments;
          this.severancePaymentsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.severancePaymentsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.shareBasedPaymentsIncludedWagesSalaries) {
          const subItem = uitsplitsing.shareBasedPaymentsIncludedWagesSalaries;
          this.shareBasedPaymentsIncludedWagesSalariesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.shareBasedPaymentsIncludedWagesSalariesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.socialSecurityContributions) {
          const subItem = uitsplitsing.socialSecurityContributions;
          this.socialSecurityContributionsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.socialSecurityContributionsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.pensionPremiums) {
          const subItem = uitsplitsing.pensionPremiums;
          this.pensionPremiumsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.pensionPremiumsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.pensionExpensesAdditional) {
          const subItem = uitsplitsing.pensionExpensesAdditional;
          this.pensionExpensesAdditionalFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.pensionExpensesAdditionalFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.employeeBenefitsExpensesOther) {
          const subItem = uitsplitsing.employeeBenefitsExpensesOther;
          this.employeeBenefitsExpensesOtherFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.employeeBenefitsExpensesOtherFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.employeeBenefitsExpensesDisclosure) {
          this.employeeBenefitsExpensesDisclosureFg.patchValue(tekstueel.employeeBenefitsExpensesDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i], {emitEvent: false});
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup, {emitEvent: false});
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.employeeBenefitsExpensesFg.updateValueAndValidity({ emitEvent: false });
    this.wagesSalariesFg.updateValueAndValidity({ emitEvent: false });
    this.severancePaymentsFg.updateValueAndValidity({ emitEvent: false });
    this.shareBasedPaymentsIncludedWagesSalariesFg.updateValueAndValidity({ emitEvent: false });
    this.socialSecurityContributionsFg.updateValueAndValidity({ emitEvent: false });
    this.pensionPremiumsFg.updateValueAndValidity({ emitEvent: false });
    this.pensionExpensesAdditionalFg.updateValueAndValidity({ emitEvent: false });
    this.employeeBenefitsExpensesOtherFg.updateValueAndValidity({ emitEvent: false });
    this.employeeBenefitsExpensesDisclosureFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          lastenUitHoofdePersoneelsbeloningen: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.lastenUitHoofdePersoneelsbeloningen,
            lastenUitHoofdePersoneelsbeloningenUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.lastenUitHoofdePersoneelsbeloningen?.lastenUitHoofdePersoneelsbeloningenUitsplitsing,
              wagesSalaries: this.wagesSalariesFg.value,
              severancePayments: this.severancePaymentsFg.value,
              shareBasedPaymentsIncludedWagesSalaries: this.shareBasedPaymentsIncludedWagesSalariesFg.value,
              socialSecurityContributions: this.socialSecurityContributionsFg.value,
              pensionPremiums: this.pensionPremiumsFg.value,
              pensionExpensesAdditional: this.pensionExpensesAdditionalFg.value,
              employeeBenefitsExpensesOther: this.employeeBenefitsExpensesOtherFg.value,
            },
            lastenUitHoofdePersoneelsbeloningenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.lastenUitHoofdePersoneelsbeloningen?.lastenUitHoofdePersoneelsbeloningenTekstueel,
              employeeBenefitsExpensesDisclosure: this.employeeBenefitsExpensesDisclosureFg.value,
            }
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }
}

